export const name = 'HpIdSignInController';
export default function HpIdSignInController(
  $stateParams,
  $state,
  $gzHpId,
  $translate,
  $location,
  $window,
  $gzEULA,
  $q,
  rnAuthService,
  rnInvitation,
  $gzAnalytics
) {
  'ngInject';

  let state;
  let invitationId;
  let eulaVersion;
  let bu;

  let vm = _.assign(this, {
    loading: true,
    signin,
    createAccount,
    goBack,
  });

  vm.unitTest = {
    handleError
  };

  activate();

  /////////////////

  function activate() {
    parseParams();

    if (!invitationId) {
      // TODO: no invitation data to go back to. Report an error in GA.
      // and display an error to the user.
      // This could happen if the user reloads this screen.
      vm.errorKey = 'register.register.Accept_Error_UnknownInvitation';
    }

    // Sign out requested to ensure a clean state.
    if ($stateParams.signout) {
      return signout();
    }

    isAuthenticated().then(() => {
      // Signed in with HP ID or PrintOS. We can now go back to accept the invitation.
      return $state.go(state, {
        invitationId,
        hpidId: $stateParams.hpidId,
        bu,
        data: {
          postAuthentication: true,
        }
      });
    }).catch(() => {
      if ($stateParams.statusCode) {
        let statusCode = $window.parseInt($stateParams.statusCode);
        let subCode = $window.parseInt($stateParams.subCode);
        handleError(statusCode, subCode);
      }

      // (This is not in a `finally` block because we don't want to show
      //  this page at all when redirecting to accept the invite.)
      vm.loading = false;
    });
  }

  function parseParams() {
    state = getState();
    vm.title = getTitle(state);
    invitationId = getInvitationId();
    bu = getBu();
  }

  function getState() {
    return $stateParams.state ? $stateParams.state : _.get($stateParams, 'data.state', null);
  }

  function getInvitationId() {
    return $stateParams.invitationId ? $stateParams.invitationId : _.get($stateParams, 'data.invitationId', null);
  }

  function getBu() {
    return $stateParams.bu ? $stateParams.bu : undefined;
  }
  /**
   * Returns a promise that is resolve if the user is authenticated
   * with HP ID or PrintOS and rejected otherwise.
   */
  function isAuthenticated() {
    if ($stateParams.hpidId) {
      return $q.resolve();
    }

    return rnAuthService.validate();
  }

  function getTitle(state) {
    let locKey;
    switch(state) {
      case 'acceptAccount':
        locKey = 'HpAccount';
        break;
      case 'acceptUser':
        locKey = 'AcceptUser';
        break;
      default:
        locKey = 'Accept_Invitation';
    }
    return $translate.instant(`register.register.${locKey}`);
  }

  function goBack() {
    return $state.go('signin', {bu});
  }

  function signin() {
    $gzAnalytics.eventClick('HP ID existing account');
    return hpidRedirect('invite');
  }

  function createAccount() {
    $gzAnalytics.eventClick('HP ID create account');
    return rnInvitation.getById(invitationId)
      .then(invitation => {
        vm.invitation = invitation;
        return hpidRedirect('invite', true);
      });
  }

  function signout() {
    return hpidRedirect('logout');
  }

  function hpidRedirect(type, createAccount = false) {
    vm.submitting = true;
    let targetUrl = $gzHpId.createTargetUrl($state.current.name, {
      state,
      invitationId,
      bu,
    });

    let data = createDataObject(createAccount);

    return $gzHpId.redirect(type, targetUrl, data, createAccount).catch(() => {
      vm.submitting = false;
      vm.errorKey = 'register.register.SignIn_Error_HPID_RedirectFailed';
    });
  }

  function createDataObject(createAccount) {
    let data = {
      eulaVersion
    };

    if (vm.invitation) {
      if (vm.invitation.email) {
        data.email = vm.invitation.email;
      }
      if (vm.invitation.firstName) {
        data.firstName = vm.invitation.firstName;
      }
      if (vm.invitation.lastName) {
        data.lastName = vm.invitation.lastName;
      }
    }

    return data;
  }

  // TODO: code cleanup. This was copied from the main sign-in controller.
  function handleError(statusCode, subCode) {
    switch(statusCode) {
      case 401:
        switch(subCode) {
          case 1000: // Need to accept EULA
            $gzEULA.show(true, null, true).then((result) => {
              vm.submitting = true;
              eulaVersion = result.eulaVersion;
              hpidRedirect('login');
            })
              .catch(() => {
                vm.errorKey = 'register.register.SignIn_Error_EulaNotAccepted';
              });
            break;
          case 1003: // Account is locked
            vm.errorKey = 'register.register.SignIn_Error_AccountLocked';
            break;
          case 1016: // Need to accept NEW EULA
            $gzEULA.show(true, null, true, true).then((result) => {
              vm.submitting = true;
              vm.signInData.eulaVersion = result.eulaVersion;
              hpidRedirect('login');
            })
              .catch((result) => {
                vm.submitting = true;
                $state.go('signin', { signout: true, bu });
              });
            break;
          default: // Unmapped 401 Error
            vm.errorKey = 'register.register.SignIn_Error_Unknown';
            break;
        }
        break;
      default: // Unknown Error
        vm.errorKey = 'register.register.SignIn_Error_Unknown';
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./components/accept/hpid-sign-in/hpid-sign-in.controller.js